var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6458 1.60493C12.7857 -0.534977 16.2552 -0.534977 18.3951 1.60493C20.535 3.74484 20.535 7.21432 18.3951 9.35423L9.35423 18.3951C7.21432 20.535 3.74484 20.535 1.60493 18.3951C-0.534977 16.2552 -0.534978 12.7857 1.60493 10.6458L10.6458 1.60493ZM17.1035 8.06268L13.2289 11.9373L8.06268 6.77113L11.9373 2.89648C13.3639 1.46987 15.6769 1.46987 17.1035 2.89648C18.5301 4.32309 18.5301 6.63607 17.1035 8.06268Z",
    fill: "#2B45D4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPill);
export default __webpack_public_path__ + "static/media/pill.b60103e1e690e503ee82760a891f30c9.svg";
export { ForwardRef as ReactComponent };